import type { CSSProperties } from 'react'
import { useTheme } from 'styled-components'

import { CenteredArea, Ring } from './Spinner.styles'

interface SpinnerProps {
  /** Diâmetro em px. Espelha a prop `size` do CircularProgress que este componente substitui. */
  size?: number
  /** Espessura do anel em px. */
  thickness?: number
  /** Cor do anel. Default: `colors.primary` do tema. */
  color?: string
  className?: string
  style?: CSSProperties
}

/**
 * Spinner local, em CSS puro.
 *
 * Existe para tirar `@mui/material` do caminho crítico: o pacote pesava 0,60 MB de código-fonte no
 * chunk inicial e era usado essencialmente para o `CircularProgress`. O `@nexds/web` não expõe
 * nenhum componente de loading, então o substituto mora aqui.
 */
export function Spinner(props: SpinnerProps) {
  const { size = 20, thickness = 2, color, className, style } = props
  const theme = useTheme()

  return (
    <Ring
      $size={size}
      $thickness={thickness}
      $color={color ?? theme?.colors?.primary ?? '#00A877'}
      className={className}
      style={style}
      role="progressbar"
      aria-label="Carregando"
    />
  )
}

/** Spinner centralizado na área disponível — usado como fallback de `Suspense`. */
export function CenteredSpinner(props: SpinnerProps) {
  return (
    <CenteredArea>
      <Spinner {...props} size={props.size ?? 28} />
    </CenteredArea>
  )
}
